import React from 'react'
import Logo from '../images/logo.svg'
import { Popover, Transition } from "@headlessui/react";
import { Link } from "gatsby";
import { TbChevronDown, TbMenu2, TbX } from 'react-icons/tb';
import routes from '../config/routes';
import { motion } from 'framer-motion';

const Nav = () => {
    const [openSolution, setOpenSolution] = React.useState(false);
    const [openProducts, setOpenProducts] = React.useState(false);

    const products = [
        {
            title: 'Messaging',
            link: `${routes.products.path}#messaging`
        },
        {
            title: 'Chatbot',
            link: `${routes.products.path}#chatbot`
        },
        {
            title: 'Native Ads',
            link: `${routes.products.path}#native-ads`
        },
        {
            title: 'Click to Whatsapp',
            link: `${routes.products.path}#click-to-whatsapp`
        },
        {
            title: 'Click to USSD',
            link: `${routes.products.path}#click-to-ussd`
        },
        {
            title: 'Video Ads',
            link: `${routes.products.path}#video-ads`
        },
    ]

    const solutions = [
        {
            title: 'Programmatic Advertising',
            link: `/solutions#dsp`
        },
        {
            title: 'Lead Generation',
            link: `${routes.solutions.path}#customer-acquisition`
        },
        {
            title: 'App Installations',
            link: `${routes.solutions.path}#customer-acquisition`
        },
        {
            title: 'Retargeting',
            link: `${routes.solutions.path}#retargeting`
        },
        {
            title: 'Customer Engagement',
            link: `${routes.solutions.path}#customer-engagement`
        },
        {
            title: 'Web and App Traffic',
            link: `${routes.solutions.path}#customer-acquisition`
        },
    ]

    const activeClassname = 'text-brand-red font-bold'
    return (
        <Popover as="header">
            {({ open }) => (
                <>
                    <div className="max-w-[1440px] mx-auto px-6 py-4 fixed top-0 w-full left-0 right-0 bg-opacity-100 z-50 bg-white">
                        <div className="flex items-center justify-between py-3 xs:px-8 md:px-8 md:space-x-10">
                            <div className="flex justify-start lg:w-0 lg:flex-1 my-auto">
                                <Link to="/">
                                    <span className="sr-only">Dochase Adx</span>
                                    <motion.img
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                        whileTap={{ scale: 0.9 }}
                                        className="w-20 lg:w-32 h-auto" src={Logo} alt="" loading='eager' />
                                </Link>
                            </div>
                            <div className="-mr-2 -my-2 lg:hidden">
                                <Popover.Button className="bg-transparent rounded-md p-2 inline-flex items-center justify-center text-black hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-transparent">
                                    <span className="sr-only">Open menu</span>
                                    <TbMenu2 className="h-9 w-9" aria-hidden="true" />
                                </Popover.Button>
                            </div>
                            <Popover.Group as="nav" className="hidden lg:flex justify-start space-x-8 my-auto">
                                <Link to='/' className='text-[#4F4F4F] hover:text-brand-red' activeClassName={activeClassname}>
                                    <motion.button
                                        whileTap={{ scale: 0.9 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    >Home</motion.button>
                                </Link>
                                <Popover className="relative">
                                    {() => (
                                        <div
                                            aria-hidden="true"
                                            onMouseEnter={() => {
                                                setOpenProducts(true);
                                            }}
                                            onMouseLeave={() => {
                                                setOpenProducts(false);
                                            }}>
                                            <Popover.Button
                                                className="group bg-transparent rounded-md inline-flex items-center pb-3"
                                            >
                                                <Link to={routes.products.path} className='text-[#4F4F4F]' activeClassName={activeClassname}>
                                                    <motion.button
                                                        whileTap={{ scale: 0.9 }}
                                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                                        className='flex hover:text-brand-red'>
                                                        Products
                                                        <TbChevronDown
                                                            className="ml-2 h-3 w-3 my-auto"
                                                            aria-hidden="true"
                                                        />
                                                    </motion.button>
                                                </Link>
                                            </Popover.Button>

                                            <Transition
                                                show={openProducts}
                                                as={React.Fragment}
                                                enter="transition ease-out duration-200"
                                                enterFrom="opacity-0 translate-y-1"
                                                enterTo="opacity-100 translate-y-0"
                                                leave="transition ease-in duration-150"
                                                leaveFrom="opacity-100 translate-y-0"
                                                leaveTo="opacity-0 translate-y-1">
                                                <Popover.Panel
                                                    static
                                                    className="absolute z-20 -ml-4 transform min-w-max lg:left-1/2 lg:-translate-x-1/2">
                                                    <div className="rounded-lg shadow-lg overflow-hidden">
                                                        <div className="relative grid gap-2 bg-white">
                                                            {products.map((item, index) => (
                                                                <Link to={item.link} key={index} className='hover:bg-red-300 w-full px-8 py-2 text-[#4F4F4F]'>{item.title}</Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Popover.Panel>
                                            </Transition>
                                        </div>
                                    )}
                                </Popover>

                                <Popover className="relative">
                                    {() => (
                                        <div
                                            aria-hidden="true"
                                            onMouseEnter={() => {
                                                setOpenSolution(true);
                                            }}
                                            onMouseLeave={() => {
                                                setOpenSolution(false);
                                            }}>
                                            <Popover.Button
                                                className="group bg-transparent rounded-md inline-flex items-center pb-3"
                                            >
                                                <Link to={routes.solutions.path} className='text-[#4F4F4F]' activeClassName={activeClassname}>
                                                    <motion.button className='flex hover:text-brand-red'
                                                        whileTap={{ scale: 0.9 }}
                                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                                                        Solutions
                                                        <TbChevronDown
                                                            className="ml-2 h-3 w-3 my-auto"
                                                            aria-hidden="true"
                                                        />
                                                    </motion.button>
                                                </Link>
                                            </Popover.Button>

                                            <Transition
                                                show={openSolution}
                                                as={React.Fragment}
                                                enter="transition ease-out duration-200"
                                                enterFrom="opacity-0 translate-y-1"
                                                enterTo="opacity-100 translate-y-0"
                                                leave="transition ease-in duration-150"
                                                leaveFrom="opacity-100 translate-y-0"
                                                leaveTo="opacity-0 translate-y-1">
                                                <Popover.Panel
                                                    static
                                                    className="absolute z-20 -ml-4 transform min-w-max lg:left-1/2 lg:-translate-x-1/2">
                                                    <div className="rounded-lg shadow-lg overflow-hidden">
                                                        <div className="relative grid gap-2 bg-white">
                                                            {solutions.map((item, index) => (
                                                                <Link to={item.link} key={index} className='hover:bg-red-300 w-full px-8 py-2 text-[#4F4F4F]'>{item.title}</Link>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </Popover.Panel>
                                            </Transition>
                                        </div>
                                    )}
                                </Popover>
                                <Link to={routes.successStories.path} className='text-[#4F4F4F] hover:text-brand-red' activeClassName={activeClassname}>
                                    <motion.button
                                        whileTap={{ scale: 0.9 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    >Success Stories</motion.button>
                                </Link>
                                <a href='https://dochase.com/creative-gallery.html' className='text-[#4F4F4F] hover:text-brand-red' activeClassName={activeClassname}>
                                    <motion.button
                                        whileTap={{ scale: 0.9 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    >Rich Media</motion.button>
                                </a>
                                <a href="https://dochaseadx.com/blog" className='text-[#4F4F4F] hover:text-brand-red' activeClassName={activeClassname}>
                                <motion.button
                                        whileTap={{ scale: 0.9 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    >Blog</motion.button>
                                </a>
                            </Popover.Group>
                            <div className="hidden lg:flex items-center space-x-5 justify-end md:flex-1 min-w-max">
                                <Link className="flex justify-center" to='/#form'>
                                    <motion.button
                                        whileHover={{ scale: 1.1 }}
                                        transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                        className='bg-brand-red text-white py-3 px-11 rounded-md font-bold'>Contact Us</motion.button>
                                </Link>
                                <motion.a
                                    whileHover={{ scale: 1.1 }}
                                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                                    href='https://dashboard.dochaseadx.com/' target='_blank'>
                                    <button className='border border-brand-red text-brand-red py-3 px-14 rounded-md font-bold'>
                                        Login
                                    </button>
                                </motion.a>
                            </div>
                        </div>
                    </div>

                    <Transition
                        show={open}
                        as={React.Fragment}
                        enter="duration-200 ease-out"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="duration-100 ease-in"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95">
                        <Popover.Panel
                            focus
                            static
                            className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right lg:hidden z-10">
                            <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                                <div className="pt-5 pb-6 px-5">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <Link to="/">
                                                <img
                                                    className="h-8 w-auto"
                                                    src={Logo}
                                                    alt=""
                                                    loading='eager'
                                                />
                                            </Link>
                                        </div>
                                        <div className="-mr-2">
                                            <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-transparent">
                                                <span className="sr-only">Close menu</span>
                                                <TbX className="h-6 w-6" aria-hidden="true" />
                                            </Popover.Button>
                                        </div>
                                    </div>
                                    <div className="mt-6">
                                        <nav className="grid gap-y-8">
                                            <Link to={routes.products.path} className='text-[#4F4F4F] text-xs flex' activeClassName={activeClassname}> Product</Link>
                                            <Link to={routes.solutions.path} className='text-[#4F4F4F] text-xs flex' activeClassName={activeClassname}> Solutions</Link>
                                            <Link to={routes.successStories.path} className='text-[#4F4F4F] text-xs flex' activeClassName={activeClassname}> Success Stories</Link>
                                        </nav>
                                    </div>
                                </div>
                                <div className="py-6 px-5 space-y-6">
                                    <div className="space-y-4">
                                        <a href='https://dashboard.dochaseadx.com/' target='_blank' rel='noreferrer'>
                                            <button className='border border-brand-red text-brand-red py-3 px-14 rounded-md font-bold w-full text-xs'>Login</button>
                                        </a>
                                        <Link className="flex justify-center" to='/#form'>
                                            <button className='bg-brand-red text-white py-3 px-14 rounded-md font-bold w-full text-xs'>Contact Us</button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </Popover.Panel>
                    </Transition>
                </>
            )}
        </Popover>
    )
}

export default Nav